module.exports = __webpack_public_path__ + "img/dundrum_medium.d5e78d8c.png";